<template>
  <div class="print-pages">
    <div v-if="data.can_show_receipt">
      <div class="ritz grid-container" dir="ltr" v-if="data.farm.name">
        <table class="waffle no-grid" cellspacing="0" cellpadding="0" :class="mobile ? 'table-mobile' : ''">
          <tbody>
            <tr style="height:19px;">
              <td colspan="7" class="s6"></td>
              <td class="s0">{{ formatDate(new Date(), "yyyy/mm/dd") }}</td>
              <td></td>
            </tr>
            <tr style="height:19px;">
              <td colspan="7" class="s6"></td>
              <td class="s1" dir="ltr">請求番号：{{ data && data.billing_id }}</td>
              <td></td>
            </tr>
            <tr style="height:40px;">
              <td class="s2" dir="ltr" colspan="8">受 領 証</td>
              <td></td>
            </tr>
            <tr style="height:14px;">
              <td colspan="9"></td>
            </tr>
            <tr style="height:28px;">
              <td class="s3" dir="ltr"></td>
              <td colspan="8" class="s7"></td>
            </tr>
            <tr style="height:36px;">
              <td class="s4" dir="ltr" colspan="2">{{ data.farm.name }} {{ $t("onchu") }}</td>
              <td colspan="7"></td>
            </tr>
            <tr style="height:18px;">
              <td class="s17" dir="ltr" colspan="1">〒810-0041</td>
              <td colspan="8" class="s1"></td>
            </tr>
            <tr style="height:18px;">
              <td class="s17" dir="ltr" colspan="1">
                {{ defaultLocation.prefecture }}{{ defaultLocation.municipality }}{{ defaultLocation.address }} {{ defaultLocation.building_name }}
              </td>
              <td colspan="8"></td>
            </tr>
            <tr style="height:18px;">
              <td colspan="6" class="s1"></td>
              <td class="s6" dir="ltr" colspan="2">〒810-0041</td>
              <td></td>
            </tr>
            <tr style="height:18px;">
              <td colspan="6"></td>
              <td class="s6" dir="ltr" colspan="2">福岡県福岡市中央区大名二丁目６−１１</td>
              <td></td>
            </tr>
            <tr style="height:18px;">
              <td colspan="6" class="s1"></td>
              <td class="s7" dir="ltr" colspan="2">Fukuoka Growth Next 2階</td>
              <td></td>
            </tr>
            <tr style="height:18px;">
              <td colspan="6"></td>
              <td class="s6" dir="ltr" colspan="2">CAVIN Inc.</td>
              <td></td>
            </tr>
            <tr style="height:18px;">
              <td colspan="6" class="s1"></td>
              <td class="s6" dir="ltr" colspan="2">TEL: 080-3858-5301</td>
              <td></td>
            </tr>
            <tr style="height:20px;">
              <td class="s10" colspan="9"></td>
              <td></td>
            </tr>
            <tr style="height:39px;">
              <td class="s11" dir="ltr" style="border-left: 1px SOLID #666666;">品目</td>
              <td class="s11" dir="ltr">品種</td>
              <td class="s11" dir="ltr">出品<br />日付</td>
              <td class="s11" dir="ltr">納品先<br />花屋</td>
              <td class="s11" dir="ltr">ロット<br />本数</td>
              <td class="s11" dir="ltr">口数</td>
              <td class="s11" dir="ltr">単価</td>
              <td class="s11" dir="ltr">金 額</td>
              <td></td>
            </tr>
            <tr
              v-for="orderItem in orderItems"
              :key="orderItem.id"
              :class="{canceled: orderItem.status === 'rollback'}"
              style="height:28px;"
            >
              <td class="s11" dir="ltr" style="border-left: 1px SOLID #666666;">{{ orderItem.flower_genus.name }}</td>
              <td class="s11" dir="ltr">{{ orderItem.flower_specie.name }}</td>
              <td class="s12" dir="ltr">{{ formatDate(orderItem.delivery_date, "m/d") }}</td>
              <td class="s12" dir="ltr">{{ orderItem.shop.name }}</td>
              <td class="s13" dir="ltr">{{ orderItem.flower_harvest.min_count }}</td>
              <td class="s13" dir="ltr">{{ orderItem.count / orderItem.flower_harvest.min_count }}</td>
              <td class="s13" dir="ltr">{{ currency(orderItem.unit_price_without_cavin_fee) }}</td>
              <td class="s13">{{ currency(orderItem.unit_price_without_cavin_fee * orderItem.count) }}</td>
              <td></td>
            </tr>
            <tr style="height:30px;">
              <td colspan="6" class="s1"></td>
              <td class="s15" dir="ltr" colspan="1" style="border-left: 1px SOLID #666666;">合 計</td>
              <td class="s16">{{ currency(data.total_price) }}</td>
              <td></td>
            </tr>
            <tr style="height:16px;">
              <td colspan="9" class="s1"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-else>
      納品が完了していません。
    </div>
  </div>
</template>

<script>
import { formatDate, currency } from "@/plugins/i18n";

export default {
  data() {
    return {
      data: {},
      deliveryDate: "",
      orderItems: [],
      defaultLocation: ""
    };
  },

  computed: {
    mobile() {
      return this.$vuetify.breakpoint.xs;
    }
  },

  async created() {
    this.deliveryDate = this.$route.query.delivery_date;
    this.orderItems = [];

    const res = await this.$http("get", `harvests/shipping_result?delivery_date=${this.deliveryDate}`);

    res.result.flower_harvests.forEach(harvest => {
      this.orderItems = this.orderItems.concat(harvest.order_items);
    });

    this.defaultLocation = res.result.farm.locations.find(location => location.default === true);
    this.data = res.result;
  },

  methods: {
    formatDate,
    currency
  },
};
</script>

<style scoped>
.print-pages {
  width: 270mm;
  table-layout: fixed;
}

.table-mobile {
  transform-origin: 0 0;
  transform: scale(0.3, 0.3);
}

.canceled {
  color: red;
}

.grid-container {
  overflow: scroll;
}
.ritz .waffle a {
  color: inherit;
}
.ritz .waffle .s4 {
  border-bottom: 1px SOLID #666666;
  background-color: #ffffff;
  text-align: left;
  color: #000000;
  font-family: "Arial";
  font-size: 16pt;
  vertical-align: bottom;
  white-space: nowrap;
  direction: ltr;
  padding: 2px 3px 2px 3px;
}
.ritz .waffle .s7 {
  background-color: #ffffff;
  text-align: right;
  color: #000000;
  font-family: "Arial";
  font-size: 9pt;
  vertical-align: bottom;
  white-space: nowrap;
  overflow: hidden;
  direction: ltr;
  padding: 2px 3px 2px 3px;
}
.ritz .waffle .s11 {
  border-bottom: 1px SOLID #666666;
  border-right: 1px SOLID #666666;
  background-color: #ffffff;
  text-align: center;
  font-weight: bold;
  font-family: "Arial";
  font-size: 11pt;
  vertical-align: middle;
  white-space: nowrap;
  direction: ltr;
  padding: 2px 3px 2px 3px;
}
.ritz .waffle .s1 {
  background-color: #ffffff;
  text-align: right;
  color: #000000;
  font-family: "Arial";
  font-size: 8pt;
  vertical-align: bottom;
  white-space: nowrap;
  direction: ltr;
  padding: 2px 3px 2px 3px;
}
.ritz .waffle .s12 {
  border-bottom: 1px SOLID #666666;
  border-right: 1px SOLID #666666;
  background-color: #ffffff;
  text-align: center;
  font-family: "Arial";
  font-size: 10pt;
  vertical-align: middle;
  white-space: nowrap;
  direction: ltr;
  padding: 2px 3px 2px 3px;
}
.ritz .waffle .s17 {
  background-color: #ffffff;
  text-align: left;
  color: #000000;
  font-family: "Arial";
  font-size: 10pt;
  vertical-align: top;
  white-space: nowrap;
  direction: ltr;
  padding: 2px 3px 2px 3px;
}
.ritz .waffle .s0 {
  background-color: #ffffff;
  text-align: right;
  color: #000000;
  font-family: "docs-Inconsolata", Arial;
  font-size: 10pt;
  vertical-align: bottom;
  white-space: nowrap;
  direction: ltr;
  padding: 2px 3px 2px 3px;
}
.ritz .waffle .s6 {
  background-color: #ffffff;
  text-align: right;
  color: #000000;
  font-family: "Arial";
  font-size: 9pt;
  vertical-align: bottom;
  white-space: nowrap;
  direction: ltr;
  padding: 2px 3px 2px 3px;
}
.ritz .waffle .s13 {
  border-bottom: 1px SOLID #666666;
  border-right: 1px SOLID #666666;
  background-color: #ffffff;
  text-align: right;
  font-family: "Arial";
  font-size: 10pt;
  vertical-align: middle;
  white-space: nowrap;
  direction: ltr;
  padding: 2px 3px 2px 3px;
}
.ritz .waffle .s3 {
  background-color: #ffffff;
  text-align: left;
  color: #000000;
  font-family: "Arial";
  font-size: 11pt;
  vertical-align: bottom;
  white-space: nowrap;
  direction: ltr;
  padding: 2px 3px 2px 3px;
}
.ritz .waffle .s16 {
  border-bottom: 1px SOLID #666666;
  border-right: 1px SOLID #666666;
  background-color: #ffffff;
  text-align: right;
  color: #000000;
  font-family: "Arial";
  font-size: 10pt;
  vertical-align: bottom;
  white-space: nowrap;
  direction: ltr;
  padding: 2px 3px 2px 3px;
}
.ritz .waffle .s2 {
  border-bottom: 2px SOLID #434343;
  background-color: #ffffff;
  text-align: center;
  color: #000000;
  font-family: "Arial";
  font-size: 24pt;
  vertical-align: bottom;
  white-space: nowrap;
  direction: ltr;
  padding: 2px 3px 2px 3px;
}
.ritz .waffle .s9 {
  background-color: #ffffff;
}
.ritz .waffle .s5 {
  background-color: #ffffff;
  text-align: left;
  color: #000000;
  font-family: "Arial";
  font-size: 10pt;
  vertical-align: bottom;
  white-space: nowrap;
  direction: ltr;
  padding: 2px 3px 2px 3px;
}
.ritz .waffle .s10 {
  border-bottom: 1px SOLID #666666;
  background-color: #ffffff;
}
.ritz .waffle .s18 {
  background-color: #ffffff;
  text-align: right;
  color: #000000;
  font-family: "Arial";
  font-size: 10pt;
  vertical-align: bottom;
  white-space: nowrap;
  direction: ltr;
  padding: 2px 3px 2px 3px;
}
.ritz .waffle .s8 {
  border-bottom: 1px SOLID #666666;
  background-color: #ffffff;
  text-align: right;
  color: #000000;
  font-family: "Arial";
  font-size: 18pt;
  vertical-align: bottom;
  white-space: nowrap;
  direction: ltr;
  padding: 2px 3px 2px 3px;
}
.ritz .waffle .s15 {
  border-bottom: 1px SOLID #666666;
  border-right: 1px SOLID #666666;
  background-color: #ffffff;
  text-align: right;
  font-weight: bold;
  color: #000000;
  font-family: "Arial";
  font-size: 10pt;
  vertical-align: bottom;
  white-space: nowrap;
  direction: ltr;
  padding: 2px 3px 2px 3px;
}
.ritz .waffle .s14 {
  border-right: 1px SOLID #666666;
  background-color: #ffffff;
  text-align: left;
  color: #000000;
  font-family: "Arial";
  font-size: 10pt;
  vertical-align: middle;
  white-space: normal;
  overflow: hidden;
  word-wrap: break-word;
  direction: ltr;
  padding: 2px 3px 2px 3px;
}

@media print {
  .print-pages {
    margin: 0;
    width: 300mm;
    page-break-after: always;
  }
  .print-pages:last-child {
    page-break-after: auto;
  }

  .table-mobile {
    transform-origin: 0 0;
    transform: scale(1, 1);
  }
}
</style>
